import { CrudModes } from "@app/shared/components/abstracts/base-component";
import { Adapter } from "@app/shared/models/adapter.model";
import { HueValue } from "@app/app-libs/material-css-vars/material-css-vars.model";
import { Field } from "@app/shared/models/form-field.model";

export const HUES: HueValue[] = [
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
  "A100",
  "A200",
  "A400",
  "A700"
];

/**
 * Enumerator: viewStates
 *
 * View component states
 *
 * Value to control which component is currently being displayed
 */
export enum viewStates {
  viewList,
  viewForm
}

/**
 * Class: ThemeParms
 *
 * Parameters used to for user profile form
 */
export class ThemeParms {
  constructor(
    public themeId: string,
    public mode: CrudModes
  ) {}
}

export interface Theme {
  themeId: string;
  description: string;
  isSelected: boolean;
}

export interface ThemeManager {
  themeId: Field;
  description: Field;
  primaryColor: Field;
  accentColor: Field;
  warningColor: Field;
  overrideWorkspace: Field;
  colorWorkspaceLight: Field;
  colorWorkspaceDark: Field;
  colorPrimaryButton: Field;
  isDarkTheme: Field;
  isAutoContrast: Field;
  contrastColorThresholdPrimary: Field;
  contrastColorThresholdAccent: Field;
  contrastColorThresholdWarn: Field;
  updateTimestamp: string;
}

/**
 * Adapter for list of themes
 */
export class ThemesAdapter implements Adapter<Theme[]> {
  adapt(rawData: any): Theme[] {
    const themesList: Theme[] = (rawData.themesList as Theme[]).map((e) => {
      e.isSelected = false;
      return e;
    });
    return themesList;
  }
}

/**
 * Adaper for a theme
 */
export class ThemeAdapter implements Adapter<ThemeManager> {
  adapt(rawData: any): ThemeManager {
    return rawData;
  }
}
